// extracted by mini-css-extract-plugin
export default {"bestsellersSection":"BestSellers_bestsellersSection__rPXf9","bestsellerProduct":"BestSellers_bestsellerProduct__1lJTa"};